import BlogDetailCards from "./BlogDetailCards";
import BlogDetailInfo from "./BlogDetailInfo";


export default function BlogDetails() {
  return (
    <>
      <BlogDetailInfo/>
      <BlogDetailCards/>
    </>
  );
}
